function calcStockAndPrice(
  price: number,
  packSpec: number,
  cartonSpec: number,
  packNumber: number,
  cartonNumber: number,
  warehouseStock: number,
  category: string
) {
  let totalPrice = 9999999
  let totalStock = 0
  totalStock = (packSpec ?? 0) * (packNumber ?? 0) + (cartonSpec ?? 0) * (cartonNumber ?? 0)
  if (category?.indexOf("现货") >= 0) {
    if ((warehouseStock ?? 0) < totalStock) {
      totalStock = warehouseStock
    }
  }

  totalPrice = Math.round(totalStock * (price ?? 0) * 100) / 100
  return {
    totalPrice,
    totalStock
  }
}


export default {
  calcStockAndPrice
};